
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"14","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.6.512a.917.917 0 100 1.834h3.667v3.666a.917.917 0 001.834 0V1.43a.917.917 0 00-.917-.917H7.601zM.9 7.214a.917.917 0 111.833 0v3.666h3.666a.917.917 0 110 1.833H1.816a.917.917 0 01-.917-.916V7.214z","fill":"#313131"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      